"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBoomerang = void 0;
var axios_1 = __importDefault(require("axios"));
var lodash_1 = require("lodash");
var BoomerangHelper_1 = require("Instrumentation/BoomerangHelper");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
function initBoomerang(apiBaseUrl, usingFeature) {
    return __awaiter(this, void 0, Promise, function () {
        var BOOMR, sendTimingData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, $.getScript("Assets/scripts/boomerang/boomerang-1.0.0.min.js")];
                case 1:
                    _a.sent();
                    BOOMR = window.BOOMR;
                    sendTimingData = usingFeature(FeatureFlag_1.default.BoomerangTimingData);
                    BOOMR.init(__assign(__assign({}, (0, BoomerangHelper_1.getCommonBoomrOptions)(sendTimingData)), { History: {
                            enabled: true,
                            routeChangeWaitFilter: BoomerangHelper_1.BoomerangHelper.routeChangeWaitFilter,
                        } }));
                    (0, BoomerangHelper_1.addAllPerformanceMarks)();
                    BOOMR.subscribe("before_beacon", function (vars) {
                        var varsClone = (0, lodash_1.cloneDeep)(vars);
                        axios_1.default.post("".concat(apiBaseUrl, "/boomerang/"), varsClone, { withCredentials: true });
                        BOOMR.fireEvent("beacon", "We sent a client beacon");
                    });
                    return [2];
            }
        });
    });
}
exports.initBoomerang = initBoomerang;
